// Types
import { CallAPI, RequestsState } from 'types'
import { ApiRequestDefaultValues } from 'modules/requests/models'

const reducer = (state: RequestsState = {}, action: CallAPI): RequestsState => {
  const { type, requestKey, actionType } = action

  const key = String(requestKey || 'default')
  if (type.endsWith('START')) {
    const requestType = type.replace('_START', '')
    return {
      ...state,
      [requestType]: {
        ...state[requestType],
        [key]: {
          isLoading: true,
          isDone: false,
          hasError: false,
        },
      },
    }
  } else if (type.endsWith('DONE')) {
    const requestType = type.replace('_DONE', '')
    return {
      ...state,
      [requestType]: {
        ...state[requestType],
        [key]: {
          isLoading: false,
          isDone: true,
          hasError: false,
        },
      },
    }
  } else if (type.endsWith('ERROR')) {
    const requestType = type.replace('_ERROR', '')
    return {
      ...state,
      [requestType]: {
        ...state[requestType],
        [key]: {
          isLoading: false,
          isDone: true,
          hasError: true,
        },
      },
    }
  }
  if (type === 'RESET_REQUEST' && actionType) {
    return {
      ...state,
      [actionType]: {
        ...state[actionType],
        [key]: ApiRequestDefaultValues,
      },
    }
  }
  return state
}

export default reducer
